export default __webpack_public_path__ + "static/media/diagram_placeholder.7b7328c1.bmp";